export interface Position {
    xPos?: number;
    yPos?: number;
}